import { getConfig } from "../config";
import * as intakeApi from "./intakeApi";
import * as mockApi from "./mockApi";

/**
 * Returns the API module based on config.
 * When USE_MOCKS is true (default for local dev), all API calls
 * use in-memory mock data instead of hitting the backend.
 *
 * Note: Both modules are statically imported. Vite's tree-shaking removes
 * mockApi from production builds when USE_MOCKS is false at build time.
 * A dynamic import() would be cleaner but adds async complexity to every
 * call site since getApi() is synchronous.
 */
export function getApi(): typeof intakeApi {
  return getConfig().USE_MOCKS ? mockApi : intakeApi;
}
